<template>
    <div class="locations__map" v-if="locations && locations.length > 0">
        <GMapMap ref="map" :center="{ lat: 40.6550558, lng: -74.1080563 }" :zoom="zoom" style="height: 679px;" :options="options">
            <GMapMarker 
                :key="index" 
                v-for="(m, index) in markers" 
                :clickable="true" 
                @click="openMarker(index)" 
                :position="m.position"
                icon="/img/offices-marker.png"
            >
                <GMapInfoWindow :closeclick="true"
                    @closeclick="openMarker(null)"
                    :opened="openedMarkerID === index">
                    <LocationCard :location="m.location" modifier="locations-card--info-window"/>
                </GMapInfoWindow>
            </GMapMarker>
        </GMapMap>
    </div>
    <div class="locations__map-key container">
        <i class="icon-map-marker"></i>
        <p>Offices</p>
    </div>
</template>

<script>
import LocationCard from "./LocationCard.vue";

export default {
    props: ["locations"],
    components: {
        LocationCard
    },
    data() {
        return {
            openedMarkerID: null,
            zoom: 5,
            options: {
                panControl: true,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                overviewMapControl: false,
                rotateControl: false,
                styles: [
                    {
                        "featureType": "all",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#202c3e"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "gamma": 0.01
                            },
                            {
                                "lightness": 20
                            },
                            {
                                "weight": "1.39"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "weight": "0.96"
                            },
                            {
                                "saturation": "9"
                            },
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#000000"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "lightness": 30
                            },
                            {
                                "saturation": "9"
                            },
                            {
                                "color": "#29446b"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "saturation": 20
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "lightness": 20
                            },
                            {
                                "saturation": -20
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "lightness": 10
                            },
                            {
                                "saturation": -30
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#193a55"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "saturation": 25
                            },
                            {
                                "lightness": 25
                            },
                            {
                                "weight": "0.01"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "lightness": -20
                            }
                        ]
                    }
                ],
            }
        }
    },
    mounted() {
        this.$refs.map.$mapPromise.then(() => {
            this.setBounds();
        });
    },
    methods: {
        openMarker(id) {
            this.openedMarkerID = id
        },
        setBounds() {
            if (this.markers) {
                const bounds = new window.google.maps.LatLngBounds();
                this.markers.map(marker => {
                    bounds.extend(marker.position);
                });
                this.$refs.map.fitBounds(bounds);
            }
        }
    },
    watch: {
        locations: function () {
            this.setBounds();
        }
    },
    computed: {
        markers: function () {
            let markers = [];
            this.locations.forEach((location) => { 
                if (location.latitude !== "" && location.longitude !== "") {
                    markers.push({
                        title: location.title,
                        location: location,
                        position: {
                            lat: parseFloat(location.latitude),
                            lng: parseFloat(location.longitude),
                        }
                    });
                }
                
            });
            return markers;
        }
    },
    
}
</script>

